import React, { useState, useRef } from 'react'
import Picker from 'emoji-picker-react';

export default function EmojiInput(props) {
    const inputRef = useRef(null); // input 요소 참조
    const [showEmoji, setShowEmoji] = useState(false);
    const [canClick, setCanClick] = useState(true); // 클릭 가능 여부를 추적

    const onEmojiClick = (event, emojiObject) => {
        const input = inputRef.current;
        if (!input) return;

        if (!canClick) return;
        setCanClick(false); 
        const { selectionStart, selectionEnd } = input;
        const value = props.value || '';

        // 커서 위치에 이모지 삽입
        const newValue =
            value.substring(0, selectionStart) +
            event.emoji +
            value.substring(selectionEnd);

        // 변경된 값 반영
        props.onChange(newValue);

        requestAnimationFrame(() => {
            input.focus();
            input.setSelectionRange(
                selectionStart + event.emoji.length,
                selectionStart + event.emoji.length
            );
        });

        setTimeout(() => {
            setCanClick(true);
        }, 300); 
    };



    const hiddenEmojis = [
        "1f30d",
        "1f30e",
        "1f30f",
        "1f310",
        "1f5fa-fe0f",
        "1f5fe",
        "1f9ed",
        "1f3d4-fe0f",
        "26f0-fe0f",
        "1f30b",
        "1f5fb",
        "1f3d5-fe0f",
        "1f3d6-fe0f",
        "1f3dc-fe0f",
        "1f3dd-fe0f",
        "1f3de-fe0f",
        "1f3df-fe0f",
        "1f3db-fe0f",
        "1f3d7-fe0f",
        "1f9f1",
        "1faa8",
        "1fab5",
        "1f6d6",
        "1f3d8-fe0f",
        "1f3da-fe0f",
        "1f3e0",
        "1f3e1",
        "1f3e2",
        "1f3e3",
        "1f3e4",
        "1f3e5",
        "1f3e6",
        "1f3e8",
        "1f3e9",
        "1f3ea",
        "1f3eb",
        "1f3ec",
        "1f3ed",
        "1f3ef",
        "1f3f0",
        "1f492",
        "1f5fc",
        "1f5fd",
        "26ea",
        "1f54c",
        "1f6d5",
        "1f54d",
        "26e9-fe0f",
        "1f54b",
        "26f2",
        "26fa",
        "1f301",
        "1f303",
        "1f3d9-fe0f",
        "1f304",
        "1f305",
        "1f306",
        "1f307",
        "1f309",
        "2668-fe0f",
        "1f3a0",
        "1f6dd",
        "1f3a1",
        "1f3a2",
        "1f488",
        "1f3aa",
        "1f682",
        "1f683",
        "1f684",
        "1f685",
        "1f686",
        "1f687",
        "1f688",
        "1f689",
        "1f68a",
        "1f69d",
        "1f69e",
        "1f68b",
        "1f68c",
        "1f68d",
        "1f68e",
        "1f690",
        "1f691",
        "1f692",
        "1f693",
        "1f694",
        "1f695",
        "1f696",
        "1f697",
        "1f698",
        "1f699",
        "1f6fb",
        "1f69a",
        "1f69b",
        "1f69c",
        "1f3ce-fe0f",
        "1f3cd-fe0f",
        "1f6f5",
        "1f9bd",
        "1f9bc",
        "1f6fa",
        "1f6b2",
        "1f6b2",
        "1f6f4",
        "1f6f9",
        "1f6fc",
        "1f68f",
        "1f6e3-fe0f",
        "1f6e4-fe0f",
        "1f6e2-fe0f",
        "26fd",
        "1f6de",
        "1f6a8",
        "1f6a5",
        "1f6a6",
        "1f6d1",
        "1f6a7",
        "2693",
        "1f6df",
        "26f5",
        "1f6f6",
        "1f6a4",
        "1f6f3-fe0f",
        "26f4-fe0f",
        "1f6e5-fe0f",
        "1f6a2",
        "2708-fe0f",
        "1f6e9-fe0f",
        "1f6eb",
        "1f6ec",
        "1fa82",
        "1f4ba",
        "1f681",
        "1f69f",
        "1f6a0",
        "1f6a1",
        "1f6f0-fe0f",
        "1f680",
        "1f6f8",
        "1f6ce-fe0f",
        "1f9f3",
        "231b",
        "23f3",
        "231a",
        "23f0",
        "23f1-fe0f",
        "23f2-fe0f",
        "1f570-fe0f",
        "1f55b",
        "1f567",
        "1f550",
        "1f55c",
        "1f551",
        "1f55d",
        "1f552",
        "1f55e",
        "1f553",
        "1f55f",
        "1f554",
        "1f560",
        "1f555",
        "1f561",
        "1f556",
        "1f562",
        "1f557",
        "1f563",
        "1f558",
        "1f564",
        "1f559",
        "1f565",
        "1f55a",
        "1f566"
    ]
    const allowCategorys = [
        {
            category: 'suggested',
            name: '최근 사용한 항목'
        },
        // {
        //     category: 'custom',
        //     name: '이모지'
        // },
        // {
        //     category: 'smileys_people',
        //     name: '얼굴 표정'
        // },
        // {
        //     category: 'animals_nature',
        //     name: '동물과 자연'
        // },
        // {
        //     category: 'food_drink',
        //     name: '음식과 음료'
        // },
        {
            category: 'travel_places',
            name: '아이콘'
        },
        {
            category: 'activities',
            name: '스포츠'
        },
        // {
        //     category: 'objects',
        //     name: '물체'
        // },
        // {
        //     category: 'symbols',
        //     name: '기호'
        // },
        // {
        //     category: 'flags',
        //     name: '국기'
        // }
    ]
    return (
        <div className={'input_div ' + props.className}>
            <div className='d-flex align-items-center '>
                <input
                    ref={inputRef}
                    className={'form-control ' + (props.errorMsg !== '' ? 'error' : '') + (props.center === true ? 'text-center' : '')}
                    placeholder={props.placeholder}
                    type={props.inputType}
                    maxLength={props.maxLength}
                    value={props.value}
                    onChange={(e) => props.onChange(e.target.value)} disabled={props.disable}
                />
                <div style={{ position: "relative" }}>
                    <div className='emoji-opener ml-16 cursor-point'
                        style={{
                            height: "30px",
                            width: "30px"
                        }}
                        onClick={() => setShowEmoji(prev => !prev)} />
                    {
                        showEmoji && <Picker
                            style={{
                                position: "absolute",
                                top: "100%",
                                right: "0px",
                                zIndex: "1",
                            }}
                            emojiStyle="apple" // 애플 스타일
                            autoFocusSearch={false}
                            searchDisabled={true}
                            pickerStyle={{ position: 'absoulte', width: "100%" }}
                            onEmojiClick={onEmojiClick}
                            categories={allowCategorys}
                            hiddenEmojis={hiddenEmojis}
                        />
                    }
                </div>

            </div>

            <div className={'invalid-feedback ' + (props.errorMsg !== '' ? 'error' : '')}>{props.errorMsg}</div>
        </div>
    )
}

